import {ChoiceSelect} from '@/components/app/choice-select';
import {useAppDispatch} from '../../../app/hooks/useAppDispatch';
import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {selectTenantId, setTenantId} from '../../auth/authSlice';
import {useIsAdmin} from '../../auth/hooks/useIsAdmin';
import {useGetAllTenantsQuery, useGetTenantsQuery} from '../../../app/services/tenantApi';
export const TenantSelect = () => {
  const dispatch = useAppDispatch();
  const tenantId = useAppSelector(selectTenantId);
  const isAdmin = useIsAdmin();
  const {data: userTenants = [], isFetching} = useGetTenantsQuery(undefined, {
    skip: !isAdmin && tenantId === 1,
  });
  const {data: allTenants = []} = useGetAllTenantsQuery(undefined, {
    skip: !isAdmin,
  });
  const tenants = isAdmin ? allTenants : userTenants;
  if (!isAdmin && tenantId === 1) {
    return null;
  }
  if (tenants.length === 0) {
    return null;
  }
  if (isFetching) {
    return null;
  }
  if (tenants.length === 1) {
    return <span className={'text-yellow-400 text-xs'}>{tenants[0].tenantName}</span>;
  }
  return (
    <ChoiceSelect
      className="border-0 p-0 shadow-none h-5 flex items-center"
      onValueChange={(e) => {
        dispatch(setTenantId(e));
      }}
      options={tenants.map((t) => ({
        label: t.tenantName,
        value: t.id,
      }))}
      optionLabel={'label'}
      optionValue={'value'}
      value={tenantId}
      valueTemplate={(option) => <span className="text-yellow-400 text-xs">{option.label}</span>}
    />
  );
};
